import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WebsiteLogoComponent } from '@lyceo/homi/shared/ui';
import { WebsiteLogoSize } from '@lyceo/homi/shared/util-models';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '@lyceo/shared/ui';
import { ButtonSize, ComponentStatus } from '@lyceo/shared/util-models';
import { UserFacade } from '@lyceo/homi/user/data-access';

@Component({
  selector: 'homi-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  imports: [WebsiteLogoComponent, TranslocoDirective, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {
  protected readonly WebsiteLogoSize: typeof WebsiteLogoSize = WebsiteLogoSize;
  protected readonly ComponentStatus: typeof ComponentStatus = ComponentStatus;
  protected readonly ButtonSize: typeof ButtonSize = ButtonSize;

  private readonly userFacade: UserFacade = inject(UserFacade);

  protected feedbackButton(): void {
    this.userFacade.topBarFeedbackClicked();
  }
}
